module.exports = __webpack_public_path__ + "8852d53bed6af9c85bb4691608c6b876.woff2";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Book.woff2
// module id = 648
// module chunks = 0